/**
 * TextControls provide an interface on top of a Text object that plays nicely with our animation presets
 */
export default class TextControls {
  /**
   * @param textObject {Text}
   */
  constructor(textObject) {
    this.textObject = textObject;
  }

  get alpha() {
    return this.textObject.alpha;
  }

  set alpha(value) {
    this.textObject.alpha = value;
  }

  getX() {
    throw new Error('Not Implemented');
  }

  get x() {
    return this.getX();
  }

  set x(value) {
    // By relying on the value returned from the getter, we invert any simple offset to the x coordinate
    this.textObject.x += value - this.x;
  }

  getY() {
    throw new Error('Not Implemented');
  }

  get y() {
    return this.getY();
  }

  set y(value) {
    // By relying on the value returned from the getter, we invert any simple offset to the y coordinate
    this.textObject.y += value - this.y;
  }

  getWidth() {
    throw new Error('Not Implemented');
  }

  get width() {
    return this.getWidth();
  }

  getHeight() {
    throw new Error('Not Implemented');
  }

  get height() {
    return this.getHeight();
  }
}
